import {acreInSF, pmtFunction} from '../../../UnderwritingSingleTenant/single-tenant-tables/constants';

export const pricingSensitivityMatrixPRO = {
    name: 'Pricing Range (Proforma)',
    description: '',
    hasNamesColumn: true,
    headerRow: [],
    rows: {
        'value': {
            name: 'Price',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= ROUNDUP(net_operating_income / cap_rate / 5000) * 5000',
                    getComputedValue(tabs, precomputedValues) {
                        const capRate = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['cap-rate'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const noiAbsouluteValue = Math.abs(precomputedValues.netOperatingIncomeProForma)
                        const value = capRate ? Math.ceil((noiAbsouluteValue / (capRate / 100) / 5000)) * 5000 : null;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                }
            }),
        },
        'cap-rate': {
            name: 'Cap Rate',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tabs) {
                        const capRate = parseFloat(tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value);
                        const bpsRate = parseFloat(tabs['pricing-tab'].tables['pricing-sensitivity-matrix-increase-pro'].rows['increase'].value);
                        const value = capRate + (-1 + index) * bpsRate;
                        const displayValue = !value || isNaN(value) ? '-' :value < 0 ? `(${(value.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2 }).replace("-",""))}%)`:`${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits :2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                };
            }),
        },
        'cash-on-cash': {
            name: 'Cash on Cash',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '%',
                    type: 'number',
                    editable: false,
                    tooltip: '= cash_flow / down_payment',
                    getComputedValue(tabs, precomputedValues) {
                        const cashFlow = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['cash-flow'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const downPayment = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['down-payment'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((cashFlow / downPayment * 100).toFixed(2));
                        const displayValue = !value || isNaN(value) || !isFinite(value) ? '-' : value < 0 ? `(${(value.toLocaleString(undefined, {minimumFractionDigits: 2 }).replace("-",""))}%)`: `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                }
            }),
        },
        'sale-price-psf': {
            name: 'PSF',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= price / total_sq_ft',
                    getComputedValue(tabs, precomputedValues) {
                        const price = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((price / precomputedValues.totalSpace).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}; }
                };
            }),
        },
        'land-price-psf': {
            name: 'PSF - Land',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= price / (lot_size * 43560)',
                    getComputedValue(tabs, precomputedValues) {
                        const price = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const lotSize = tabs['property-information-tab'].tables['other-information'].rows['lot-size'].value;
                        const value = parseFloat(price / (lotSize * acreInSF)).toFixed(2);
                        const displayValue  = value && !isNaN(value) && isFinite(value) ? `$${value.toLocaleString()}` : '-';
                        return {internalValue: value, displayValue: displayValue};
                    }
                }
            }),
        },
        'down-payment': {
            name: 'Down Payment',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= price * down_payment_percentage',
                    getComputedValue(tabs, precomputedValues) {
                        const isAssumableLoan = tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
                        if(isAssumableLoan && index===1){
                            const value = tabs['pricing-tab'].tables['down-payment'].rows['down-payment'].valueCells[2].value;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                        else{
                            const downPayment = tabs['pricing-tab'].tables['down-payment'].rows['down-payment'].valueCells[1].value;
                            const price = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = price * downPayment / 100;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }
                }
            }),
        },
        'loan-amount': {
            name: 'Loan Amount',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= price - down_payment',
                    getComputedValue(tabs, precomputedValues) {
                        const isAssumableLoan = tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
                        if(isAssumableLoan && index===1){
                            const value = tabs['pricing-tab'].tables['loan-amount'].rows['loan-amount'].valueCells[2].value;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                        else {
                        const price = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const downPayment = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['down-payment'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = price - downPayment;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue};
                    }
                    }
                }
            }),
        },
        'loan-payment': {
            name: 'Loan Payment',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= -PMT(interest_rate/12, amortization*12, loan_amount) * 12',
                    getComputedValue(tabs, precomputedValues) {
                        const amortization = tabs['pricing-tab'].tables['interest-rate'].rows['amortization'].valueCells[2].value;
                        const loanAmount = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['loan-amount'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const interestRate = tabs['pricing-tab'].tables['interest-rate'].rows['interest-rate'].valueCells[2].value;
                        let value;
                        if((!amortization || amortization == 0 ) && loanAmount && interestRate){
                            value = parseInt( (interestRate /100) * loanAmount);
                        }
                        else{
                            value = parseInt(-pmtFunction(interestRate/100/ 12, amortization * 11.8, loanAmount) * 12);                              
                        }
                        if(value){
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                        return {internalValue: '-', displayValue: '-'}
                    }
                }
            }),

        },
        'cash-flow': {
            name: 'Cash Flow',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= net_operating_income - loan_payment',
                    getComputedValue(tabs, precomputedValues) {                                             
                        const debtService = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['loan-payment'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = precomputedValues.netOperatingIncomeProForma - debtService;
                        const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(value.toLocaleString().replace("-",""))})`: `$${value.toLocaleString()}`;
                        return {internalValue: value, displayValue: displayValue};                        
                    }
                }
            }),

        },
        'dc-ratio': {
            name: 'DSCR',
            valueCells: ([...new Array(5)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    tooltip: '= net_operating_income / loan_payment',
                    getComputedValue(tabs, precomputedValues) {
                        const debtService = tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['loan-payment'].valueCells[index].getComputedValue(tabs, precomputedValues).internalValue;
                        const value = parseFloat((precomputedValues.netOperatingIncomeProForma / debtService).toFixed(2));
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue}
                    }
                }
            }),
        }
    },
};

export const pricingSensitivityMatrixIncreasePRO = {
    rows: {
        'increase': {
            name: 'BPS change',
            editable: true,
            type: 'number',
            unit: '%',
            value: 0.25
        }
    }
};
